import { AbstractControl, ValidationErrors } from "@angular/forms";
import { isValidEmail } from "./is-email-validator";

export function validateEmail(control: AbstractControl): ValidationErrors | null {

    const value = control.value;

    if (!value) {
        return null;
    }

    return isValidEmail(value) ? null : { email: true };
}